const INFO = {
	main: {
		title: "Portfolio of Sardar Sain",
		name: "Sardar Sain",
		email: "sardarsain638@gmail.com",
		logo: "../logo.jpg",
	},

	socials: {
		twitter: "https://twitter.com/", // Add if available
		github: "https://github.com/", // Add personal GitHub link
		linkedin: "https://linkedin.com/", // Add personal LinkedIn link
		instagram: "https://instagram.com/", // Add if available
		stackoverflow: "https://stackoverflow.com/", // Add if available
		facebook: "https://facebook.com/", // Add if available
	},

	homepage: {
		title: "Full-stack developer and enthusiastic learner.",
		description:
			"I am a full-stack web developer with expertise in PHP, JavaScript, ReactJS, NodeJS, and more. With experience working on diverse projects, I enjoy building scalable web solutions and working with cross-functional teams. My passion lies in continuous learning and enhancing my technical skill set while contributing to innovative projects.",
	},

	about: {
		title: "I’m Sardar Sain. Based in Ajmer, India, designing web solutions for the future.",
		description:
			"Currently, I work as a Website Development Executive at Surgeped, where I contribute to various web development projects, leveraging my skills in PHP, JavaScript, and ReactJS. I have led server-side operations, developed dynamic websites, and mentored junior developers. Always open to collaboration and new opportunities to learn, I aim to create impactful digital experiences.",
	},

	articles: {
		title: "Sharing insights on web development, tech trends, and personal projects.",
		description:
			"A collection of my thoughts on full-stack development, programming languages, and modern web technologies.",
	},

	projects: [
		{
			title: "Recipe Management System",
			description:
				"Developed a Django web app for managing recipes, including user authentication, data visualization, and a clean front-end with HTML, CSS, and Chart.js.",
			logo: "../recipemanager.jpeg",
			linkText: "View Project",
			link: "https://github.com/sardarsain67/recipemanager", // Add personal GitHub link for project
		},
		{
			title: "Car Rental Platform",
			description:
				"Built a full-featured platform for browsing and renting cars, complete with user sign-ups, admin-approved car listings, and secure payment options.",
			logo: "../carrent.jpeg",
			linkText: "View Project",
			link: "https://github.com/sardarsain67/carrent", // Add personal GitHub link for project
		},
		{
			title: "Handmade Selling Website",
			description:
				"A platform where users can explore multiple handmade products and purchase them easily. Users can also enroll to sell products, which will be approved by the admin before being added to the website. The site includes order tracking functionality.",
			logo: "handmade.jpeg",
			linkText: "View Project",
			link: "https://github.com/sardarsain67/handmade/", // Add personal GitHub link for project
		},
		{
			title: "Assignment Help Website",
			description:
				"A platform where students can find assistance for their assignments. Users can add their assignments for help, with links to examples like nexassignment.com and academiaassist.com.",
			logo: "assignment.jpeg",
			linkText: "View Project",
			link: "https://academiassist.com/", // Add personal GitHub link for project
		},
		{
			title: "Email Marketing Tool",
			description:
				"Created a secure tool for personalized email marketing campaigns, integrating Excel, performance tracking, and scheduling features using EJS, Node.js, and MongoDB.",
			logo: "email.jpg",
			linkText: "View Project",
			link: "https://github.com", // Add personal GitHub link for project
		},
		{
			title: "Gamified Learning Website",
			description:
				"Developed a platform for gamified learning with lesson sequences, rewards, and leaderboards, built with React, Node.js, and MongoDB.",
			logo: "learning.jpeg",
			linkText: "View Project",
			link: "https://github.com", // Add personal GitHub link for project
		},
		{
			title: "iNotebook",
			description:
				"A note-taking application built with React.js and Node.js, allowing users to add daily notes and set reminders for upcoming tasks.",
			logo: "inotebook.png",
			linkText: "View Project",
			link: "https://github.com/sardarsain67/inotebook", // Add personal GitHub link for project
		},
		{
			title: "Multicultural Wedding Planner",
			description: "A comprehensive wedding planning platform that manages all functions related to weddings, including music, dress, catering, and various cultural functions.",
			logo: "wedding.jpeg", // Replace with your project image path
			linkText: "View Project",
			link: "https://github.com/sardarsain67/wedding", // Add personal GitHub link for project
		  },
		  {
			title: "University Placement Portal",
			description: "The University Placement Portal streamlines communication between TPO, students, and companies. TPO adds profiles, schedules drives, and shares news. Students access details and update profiles, ensuring efficient coordination for successful placements.",
			logo: "university.jpeg", // Replace with your project image path
			linkText: "View Project",
			link: "https://github.com/sardarsain67/placementportal", // Add personal GitHub link for project
		  },
	],
 
	education: {
		school: "Central University of Rajasthan",
		degree: "Bachelor of Technology (B.Tech), Computer Science & Engineering",
		duration: "2019–2023",
		location: "Ajmer, India",
	},

	experience: {
		title: "Website Development Executive at Surgeped, Jaipur",
		duration: "Jan 2023 – Present",
		description: [
			"Worked on diverse projects using PHP, HTML, CSS, JavaScript, ReactJS, NodeJS, Java Swing, .NET, and Python.",
			"Developed and launched websites like nexassignment.com, academiaassist.com, and surgewave.",
			"Managed server-side operations, hosting solutions, and mentored junior developers.",
			"Collaborated with cross-functional teams and provided technical solutions in client meetings."
		],
	},

	resume: {
		file: "sardar_updated_resume.pdf", // The PDF file for download
		education: [
		  {
			school: "Central University of Rajasthan",
			degree: "Bachelor of Technology (B.Tech), Computer Science & Engineering",
			duration: "2019–2023",
			location: "Ajmer, India",
		  },
		  {
			school: "Gov. Sr. Sec. School (RBSE board), Kishangarh, Ajmer",
			degree: "Senior Secondary (XII), Science",
			duration: "2017",
		  },
		],
		training: [
		  {
			title: "Website Development Executive Training",
			organization: "Surgeped, Jaipur",
			duration: "Jan 2023 – Jun 2023",
			description: "Worked on PHP, Node.js, React for dynamic websites."
		  },
		  {
			title: "PHP Training",
			organization: "Pace InfoTech, Jaipur (Online)",
			duration: "Jan 2022 – Aug 2022",
			description: "Trained in web development with PHP, HTML, CSS, JavaScript."
		  },
		],
		experience: {
		  title: "Website Development Executive",
		  organization: "Surgeped, Jaipur",
		  duration: "Jan 2023 – Present",
		  achievements: [
			"Developed and launched websites such as nexassignment.com, academiaassist.com.",
			"Managed server-side operations and provided hosting solutions.",
			"Mentored junior developers and collaborated with cross-functional teams."
		  ]
		}
	  },

	skills: {
		title: "Technical Skills",
		description: [
			"Languages: Java, C, PHP, JavaScript, HTML/CSS, Bootstrap",
			"Frameworks: React.js, Node.js, ASP.NET",
			"Developer Tools: Git, VS Code, Visual Studio",
			"Databases: MySQL, MongoDB, SQLite"
		],
	},
};

export default INFO;
